<template>
  <main class="shop-item" :key="item.uid">
      <section class="item-gallery">
            <slideshow :images="item.content.images" :index="0" />
      </section>
      <section class="item-info">
            <div class="item-info-left">
                  <h1>{{ item.title }}</h1>
                  <h2>€ {{ item.content.price }}<br>+ Shipping</h2>
                  <button v-if="!added && !item.content.soldout" @click="addToCart" class="buy-button">
                        <span>B</span>
                        <span>U</span>
                        <span>Y</span>
                  </button>
                  <button v-if="added" class="buy-button soldout" disabled>
                        <span>A</span>
                        <span>D</span>
                        <span>D</span>
                        <span>E</span>
                        <span>D</span>
                  </button>
                  <button v-if="item.content.soldout" class="buy-button soldout" disabled>
                        <span>S</span>
                        <span>O</span>
                        <span>L</span>
                        <span>D&nbsp;</span>
                        <span>O</span>
                        <span>U</span>
                        <span>T</span>
                  </button>
                  <div>
                        <router-link :to="{ name: 'terms' }">Terms & Conditions</router-link>
                  </div>

            </div>
            <div class="item-info-right txt" v-html="item.content.description">
            </div>
      </section>
  </main>
</template>

<script>
import Slideshow from "@/components/Slideshow";
export default {
      metaInfo() {
            return {
                  title: "– " + this.item.title
            };
      },
      components: {
            Slideshow
      },
      props: {
            id: String
      },
      data() {
            return {
                  variant: null,
            };
      },
      computed: {
            shop() {
                  return this.$store.state.shop;
            },
            item() {
                  let shop = this.shop;
                  const result = shop.filter(item => item.uid == this.id);
                  return result[0];
            },
            added() {
                  return this.$store.state.cart.some(item => item.uid == this.item.uid);
            }
      },
      mounted() {
            if(this.item) {
                  console.log(this.item);
                  if(Object.keys(this.item.content.variants).length > 0) {
                        this.variant = Object.values(this.item.content.variants)[0];
                  }
            }
      },
      methods: {
            addToCart() {
                  let item = this.item;
                  item["quantity"] = 1;
                  this.$store.commit("addToCart", item);
            },
      }
};
</script>

<style lang="scss" scoped>
.shop-item {
      padding-top: 5em !important;
      padding-left:0 !important;
      padding-right:0 !important;
      .item-gallery {
            margin-bottom: 6em;
      }
      .item-info {
            padding:0 1em;
            display:grid;
            grid-template-columns: 1fr 2fr;
            margin-bottom: 4em;
            .item-info-right {
                  max-width: 80ch;
            }
            @media only screen and (max-width: 768px) {
                  grid-template-columns: 1fr;
                  grid-gap:1em;
            }
      }
      button.buy-button {
            font-family: "Walter", sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            font-variant-ligatures: none;
            font-feature-settings: "liga" 0, "clig" 0;
            font-size: 0.9rem;
            letter-spacing: 0.3em;
            line-height: 1.3;
            background:white;
            padding:0.75em 0.8em 0.5em 1em;
            text-transform: uppercase;
            appearance: none;
            border: 0px;
            cursor:pointer;
            margin: 1em 0 2em;
            span {
                  display:inline-block;
                  transition: transform 0.2s ease-in-out;
            }
            &:hover span:nth-child(1) {
                  transform: translateY(-10%);
            }
            &:hover span:nth-child(2) {
                  transform: translateY(15%);
            }
            &:hover span:nth-child(3) {
                  transform: translateY(-5%);
            }
            &:hover span:nth-child(4) {
                  transform: translateY(5%);
            }
            &:hover span:nth-child(5) {
                  transform: translateY(10%);
            }
            &:hover span:nth-child(6) {
                  transform: translateY(-5%);
            }
            &:hover span:nth-child(7) {
                  transform: translateY(-15%);
            }
            &.soldout {
                  background: rgba(255,255,255,0.5);
                  color: #999;
                  cursor: default;
            }
      }
}
</style>
